import axios from "axios";

// En dev, Vite relaie /api vers http://localhost:9500. En production, Nginx
// relaie le même chemin vers le service API du réseau Docker.
const BASE_URL = import.meta.env.VITE_API_URL ?? "/api";

export default axios.create({
    baseURL: BASE_URL,
    withCredentials: false, // aucune session : ce client n'authentifie jamais personne
});
